<template>
  <b-modal
    id="select-prospect-template-modal"
    ref="modal"
    class="select-prospect-template-modal"
    size="lg"
  >
    <div v-if="!templates">
      <Loader />
    </div>

    <div v-else>
      <form-component>
        <h5
          class="mb-3"
        >
          Select a Prospect Template to copy url
        </h5>
        <input-select
          v-model="selectedTemplate"
          label="Select Template"
          type="select"
          :options="templateOptions"
        />
      </form-component>
    </div>


    <template slot="modal-footer">
      &nbsp;

      <button
        class="btn"
        @click="hide()"
      >
        Close
      </button>

      <!-- <button
        class="btn btn-primary"
        @click="copyUrl()"
      >
        Copy
      </button> -->
    </template>
  </b-modal>
</template>

<script>
import Loader from '@/components/Loader.vue';
import FormComponent from '@/components/FormComponent.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
  name: 'SelectProspectTemplateModal',
  components: {
    Loader,
    InputSelect,
    FormComponent,
  },
  props: {
    
  },
  data() {
    return {
      templates: null,
      selectedTemplate: '',
    };
  },
  computed: {
    templateOptions() {
      return (this.templates || []).map(t => ({ id: t.id, display_label: t.name }));
    },
  },
  watch: {
    selectedTemplate(v) {
      setTimeout(() => {
        this.copyUrl();
      }, 300);
    },
  },
  methods: {
    copyUrl() {
      if (this.selectedTemplate) {
        const model = this.templates.filter(t => t.id === parseInt(this.selectedTemplate, 0));

        if (model.length) {
          const url = model[0].prospectUrl;
          const clipboardData = (event && event.clipboardData) || window.clipboardData || (event && event.originalEvent && event.originalEvent.clipboardData) || navigator.clipboard;
          if (clipboardData) {
            clipboardData.writeText(url);
            this.$globals.showSuccess('Link copied to clipboard!');
          }
        }
      }
    },
    show(product) {
      this.templates = null;
      this.$refs.modal.show();

      if (product && product.templates) {
        this.templates = product.templates;
      } else if (product) {
        this.$globals.userClient.getProductTemplates(product.id, true).then(res => {
          this.templates = res.items;
        }).catch(ex => {
          this.templates = [];
        });
      }
    },
    hide() {
      this.saving = false;
      this.$refs.modal.hide();
    },
  },
};
</script>

<style lang="scss">
.big-option {
  width: 100%;
  text-align: left;
  margin-bottom: 5px;
  position: relative;
  height: 70px;

  .fa-search,
  .fa-chart-line,
  .fa-user-chart,
  .fa-ballot-check,
  .fa-usd-square {
    margin-right: 10px;
    margin-right: 15px;
    font-size: 21px;
    position: relative;
    top: 3px;
  }

  .right {
    position: absolute;
    right: 15px;
    top: 23px;
  }

  &.capped {
    @media (min-width: $md-min) {
      width: auto;
      min-width: 250px;
      margin-left: 5px;
      margin-right: 5px;
    }

    &.main {
      background: $blue;
      border-color: $blue;
      color: white;

      &:hover {
        background: darken($blue, 5%);
        border-color: darken($blue, 5%);
      }
    }
  }
}

.step-number {
  margin-top: 30px;
  opacity: 0.6;
  margin-bottom: 0;
}

a.big-option {
  padding-top: 17px;
}

.input-with-close {
  .left {
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 65px);
  }

  .right {
    display: inline-block;
    vertical-align: top;
    width: 61px;

    .btn {
      height: 60px;
      width: 60px;
      margin-left: 5px;
    }
  }
}
</style>
